import React from "react";
import { TableFooter, TableRow, TableCell } from "@material-ui/core";

import { IUserBySubTableProps } from "../UsersBySubscriptionTable";
import { Pagination } from "../../../components/Pagination";

export const UserBySubTableFooter: React.FunctionComponent<
  IUserBySubTableProps
> = ({ onChangePage, pagination, totalItems }) => (
  <TableFooter>
    {onChangePage && (
      <TableRow>
        {pagination && (
          <TableCell>
            <Pagination
              totalItems={totalItems || 0}
              pagination={pagination}
              onChangePage={onChangePage}
            />
          </TableCell>
        )}
      </TableRow>
    )}
  </TableFooter>
);
